<template>
  <div class="step-icon">
    <figure>
      <slot />
    </figure>
    <p v-if="text" v-safe-html="text" />
  </div>
</template>

<script>
export default {
  name: "StepIcon",
  props: {
    text: String
  }
};
</script>

<style scoped>
.step-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  text-align: center;
}
p {
  margin: 0px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #121212;
}
figure {
  margin: 0;
  max-height: 100px;
  width: 100%;
  margin-bottom: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}
figure >>> img {
  display: block;
  height: 100px;
  max-width: 100px;
  width: auto;
}
</style>
